<template>
    <div class="section-box news-detail" v-if="detail">
        <div style="width: 690px;margin-left: auto;margin-right: auto;">
            <div class="list-wrapper">
                <h3 class="new-article-title">{{detail.Title}}</h3>
                <div v-html="detail.Content"></div>
                <div class="new-operation-btn" style="height: 88px;">
                    <span class="issue-time">发布于{{detail.CreateTime_MMDD}}·著作权归作者所有</span>
                    <div class="operation-btn">
                        <span class="dz">{{detail.ThumbUpCount}}</span>
                        <span class="sc">{{detail.CollectCount}}</span>
                        <template v-if="!detail.IsDelete">
                            <el-dropdown trigger="click" placement="bottom" @command="commandMore">
                                <span class="icon-more">点点点</span>
                                <el-dropdown-menu slot="dropdown" class="text-center">
                                    <el-dropdown-item command="n" v-if="!detail.IsAuthorView">仅作者可见</el-dropdown-item>
                                    <el-dropdown-item command="d">删除</el-dropdown-item>
                                    <el-dropdown-item command="y" v-if="detail.IsAuthorView" divided>恢复可见</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <el-button type="info" size="small" v-else disabled>已删除</el-button>
                        <!-- <el-button type="danger" size="small" v-if="!detail.IsDelete" @click="getOperationReason(1)">删除</el-button>
                        <el-button type="info" size="small" v-else disabled>已删除</el-button> -->
                    </div>
                </div>
                <div style="height: 10px;background: #f9f9f9;font-size: 0;">分割线</div>
                <div class="contentNum-actions">
                    <div class="comment-number">
                        <i>{{detail.CommentCount}}</i>
                        <span>评论</span>
                    </div>
                    <div class="actions-btn">
                        <span :class="{'on':sortType==1}" @click="hotList">热度</span>
                        <span class="new" :class="{'on up':sortType==0,'on down':sortType==2}" @click="optionList">最新</span>
                    </div>
                </div>
                <div class="comment-content-box">
                    <ul class="comment-content-list">
                        <li class="comment-item" v-for="(item,index) in commentList" :key="index">
                            <div class="item-user-portrait">
                                <img :src="item.HeadImgUrl" alt="头像" />
                            </div>
                            <div class="item-user-info">
                                <h4>{{item.UserName}}<span v-if="item.IsAuthor" class="me">作者</span></h4>
                                <div>
                                    <el-button type="danger" size="mini" v-if="!item.IsDelete" @click="getOperationReason(2,1,item.Id,index)">删除</el-button>
                                    <el-button type="info" size="mini" v-else disabled>已删除</el-button>
                                </div>
                            </div>
                            <p class="item-test" v-html="renderTxt(item.Content)"></p>
                            <div class="item-img-list" v-if="item.ImgList && item.ImgList.length">
                                <div class="item-img-item" v-for="(img,idx) in item.ImgList" :key="idx">
                                    <img :src="img" :preview="index" alt="图片">
                                </div>
                            </div>
                            <div class="new-operation-btn" style="margin-top: 15px;">
                                <span class="issue-time" style="color: #666666;">{{item.CreateTime}}<span v-if="item.IsAuthorReply"> · 作者回复了</span></span>
                                <div class="operation-btn">
                                    <span class="dz">{{item.ThumbUpCount}}</span>
                                </div>
                            </div>
                            <div class="items-comment-content-box">
                                <el-collapse-transition>
                                    <ul class="items-comment-content-list" v-show="item.showList" v-if="item.ChildCommentList instanceof Array && item.ChildCommentList.length">
                                        <li class="items-comment-item" v-for="(items,indexs) in item.ChildCommentList" :key="indexs">
                                            <div class="item-user-info">
                                                <div class="items-hf"><span>{{items.UserName}}</span><i style="font-style: normal">回复</i><span>{{items.ParentUserName}}</span>：</div>
                                                <div>
                                                    <el-button type="danger" size="mini" v-if="!items.IsDelete" @click="getOperationReason(2,2,items.Id,index,indexs)">删除</el-button>
                                                    <el-button type="info" size="mini" v-else disabled>已删除</el-button>
                                                </div>
                                            </div>
                                            <p class="items-item-test" v-html="renderTxt(items.Content)"></p>
                                            <div class="item-img-list" v-if="items.ImgList && items.ImgList.length">
                                                <div class="item-img-item" v-for="(img,idx) in items.ImgList" :key="idx">
                                                    <img :src="img" :preview="index" alt="图片">
                                                </div>
                                            </div>
                                            <div class="new-operation-btn" style="margin-top: 15px;">
                                                <span class="issue-time" style="color: #666666;">{{items.CreateTime}}</span>
                                                <div class="operation-btn">
                                                    <span class="dz">{{items.ThumbUpCount}}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </el-collapse-transition>
                                <div class="look-more" v-if="item.ChildCommentList && item.ChildCommentList.length">
                                    <span @click="item.showList = !item.showList">{{item.showList?'收起':'展开'}}全部 <b>{{item.ChildCommentList.length}}</b> 条回复</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <el-dialog 
            class="report-dialog"
            :visible.sync="showReport"
            title="删除"
            width="30%"
        >
            <div class="report-box">
                <div class="issue-one">
                    <label for="" class="issue-label"><i style="color: red;">* </i>请选择删除原因</label>
                    <ul class="option-report-list">
                        <li :class="{'on':item.Id == ReasonId}" v-for="(item,index) in operationReason" :key="index" @click="ReasonId = item.Id">{{item.Reason}}</li>
                    </ul>
                </div>
                <div class="report-btn">
                    <button @click="forumComplain">确认</button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        GetPostDetail,          //获取帖子详情
        GetPostCommentList,     //获取帖子评论
        GetOperationReason,     //获取删除原因
        DeletePost,             //删除帖子
        DeletePostComment,      //删除帖子评论
        SwitchPostIsAuthorView, //帖子是否本人可见
    } from "@/service/run";
    export default {
        data() {
            return {
                detail: null,
                commentList: [],
                pageNum:1,
                pageSize:10,
                total:0,
                loading:false,
                sortType: 0,
                isUpDown: true,

                operationReason: [],      //删除原因
                ReasonId: '',             //删除原因id

                showReport: false,
                isPost: 1,                //是否是帖子 1是 2是评论

                i: -1,       //一级评论还是二级评论
                id: -1,      //评论id
                idx: -1,     //第几个评论
                idxs: -1,    //第几个子集评论
            }
        },
        activated(){
        },
        created() {
            
        },
        computed: {
        },
        mounted() {
        },
        methods: {
            // 获取信息
            init(){
                this.GetPostDetailInfo();
                this.loading = false
                this.detail = null
                this.commentList = []
                this.pageNum = 1
                this.pageSize = 10
                this.total = 0
                this.onScroll();
            },
            // 获取详情
            GetPostDetailInfo(){
                GetPostDetail({
                    PostId: this.$route.query.id,
                }).then(res=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    } 
                    this.detail = res.Data
                    this.getPostCommentList();
                })
            },
            // 点击更多
            commandMore(command){
                switch(command) {
                    case "n":  //开启作者可见
                        this.switchAuthorSee()
                        break;
                    case "d":  //删除
                        this.getOperationReason(1)
                        break;
                    case "y":  //关闭作者可见
                        this.switchAuthorSee()
                        break;

                }
            },
            // 获取评论
            getPostCommentList(){
                if(this.loading==true){
                    return;
                }
                this.loading=true;
                GetPostCommentList({
                    PostId: this.$route.query.id,
                    SortType: this.sortType,
                    PageNum: this.pageNum,
                    PageSize: this.pageSize,
                }).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    let list=res.Data.PostCommentList ||[];
                    let lists = list.map(elem=>{
                        elem.showList = false
                        return elem
                    })
                    if(this.pageNum==1){
                        this.commentList = []
                        this.commentList = lists
                    }else{
                        this.commentList=this.commentList.concat(lists);
                    }
                    if(this.pageSize==lists.length){
                        this.loading=false;
                        this.pageNum=this.pageNum+1;
                    }
                })
            },
            //滚动加载
            onScroll(){
                let scrollTop=document.documentElement.scrollTop;
                let that=this;
                document.onscroll=function () {
                    let clientHeight=document.documentElement.clientHeight;
                    let offsetHeight=document.documentElement.offsetHeight;
                    let st=document.documentElement.scrollTop;
                    let flag=0;//向下滚动时变成1；
                    if(st>scrollTop){
                        flag=1;
                    }else{
                        flag=0;
                    }
                    scrollTop=st;
                    if(offsetHeight-clientHeight-50<=st && flag){
                        that.getPostCommentList();
                    }
                }
            },
            //渲染表情图片
            customEmoji(value) {
                var html='';
                var str = value.replace(/\[|]/g,'')
                html=`<img src="https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Emoji/${str}.png" style="width:30px"/>`
                return html;
            },
            //渲染消息文字和表情图片
            renderTxt(txt = "") {
                let rnTxt = [];
                let match = null;
                const regex = /(\[.*?\])/g;
                // const regex = /\[|]/g;
                let start = 0;
                let index = 0;
                while ((match = regex.exec(txt))) {
                    index = match.index;
                    if (index > start) {
                        rnTxt.push(txt.substring(start, index));
                    }
                    rnTxt.push(this.customEmoji(match[1]));
                    start = index + match[1].length;
                }
                rnTxt.push(txt.substring(start, txt.length));
                return rnTxt.join('');//.replace(/,/g, "")
            },
            // 点击热度
            hotList() {
                if(this.sortType == 1) {
                    return
                }
                this.sortType = 1
                this.loading=false;
                this.pageNum = 1;
                this.pageSize = 10;
                this.getPostCommentList();
            },
            // 点击最新
            optionList(){
                if(this.sortType == 0) {
                    this.sortType = 2
                }else {
                    this.sortType = 0
                }
                this.loading=false;
                this.pageNum = 1;
                this.pageSize = 10;
                this.getPostCommentList();
            },
            // 获取投诉选项
            getOperationReason(is,i,id,idx,idxs){
                this.showReport = true
                this.isPost = is
                this.i = i
                this.id = id
                this.idx = idx
                this.idxs = idxs
                GetOperationReason({
                    type: 6
                }).then(res=> {
                    this.operationReason = res.Data
                })
            },
            // 点击删除
            forumComplain() {
                if(!this.ReasonId) {
                    return this.$toast('请选择删除原因！');
                }
                let self = this
                if(this.isPost == 1) {
                    // 删除的帖子
                    DeletePost({
                        PostId: self.$route.query.id,
                        ReasonId: self.ReasonId
                    }).then(res=> {
                        if(res.Result != 1) {
                            return this.$message.error(res.Message)
                        }
                        self.$message.success(res.Message)
                        self.showReport = false
                        self.detail.IsDelete = !self.detail.IsDelete
                        self.ReasonId = ''
                    })
                }else {
                    // 删除的帖子内容
                    DeletePostComment({
                        CommentId: self.id,
                        ReasonId: self.ReasonId,
                    }).then(res=> {
                        if(res.Result != 1) {
                            return self.$message.error(res.Message)
                        }
                        self.$message.success(res.Message)
                        self.showReport = false
                        self.ReasonId = ''
                        if(self.i == 1) {
                            self.commentList[self.idx].IsDelete = 
                            !self.commentList[self.idx].IsDelete
                        }else {
                            self.commentList[self.idx].ChildCommentList[self.idxs].IsDelete = 
                            !self.commentList[self.idx].ChildCommentList[self.idxs].IsDelete
                        }
                    })
                }
            },

            // 是否作者可见
            switchAuthorSee(){
                let data = {}
                data.PostId = this.$route.query.id
                SwitchPostIsAuthorView(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success("操作成功！")
                    this.detail.IsAuthorView = !this.detail.IsAuthorView
                })
            },
        },
        destroyed() {
            document.onscroll=null;
        },
    }
</script>
<style lang="scss">
    .news-detail {
        .list-wrapper {
            width: 690px;
            .new-article-title {
                font-size: 32px;
                color: #333333;
                font-weight: bold;
                line-height: 36px;
                margin-bottom: 30px;
            }
            .new-operation-btn {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .issue-time {
                    font-size: 16px;
                    color: #999999;
                    font-weight: 400;
                }
            }
        }
        .operation-btn {
            display: flex;
            align-items: center;
            .dz,
            .sc {
                margin-left: 20px;
                color: #999999;
                font-size: 18px;
                line-height: 22px;
                padding-left: 24px;
                background-repeat: no-repeat;
                background-position: left center;
                cursor: pointer;
            }
            .dz {
                background-image: url('~@/assets/new/icon-no-praise.png');
            }
            .sc {
                margin-right: 20px;
                background-image: url('~@/assets/new/icon-no-collect.png');
            }
            .icon-more {
                display: inline-block;
                vertical-align: top;
                width: 22px;
                height: 22px;
                background-image: url('~@/assets/new/icon-more.png');
                background-repeat: no-repeat;
                background-position: center center;
                font-size: 0;
                cursor: pointer;
            }
        }
        .contentNum-actions {
            height: 106px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .comment-number {
                i {
                    font-size: 34px;
                    color: #f75959;
                    font-weight: bold;
                    font-style: normal;
                }
                span {
                    padding-left: 6px;
                    font-size: 22px;
                    color: #333333;
                    font-weight: bold;
                }
            }
            .actions-btn {
                background: #eeeeee;
                padding: 4px 5px;
                height: 30px;
                border-radius: 19px;
                display: flex;
                align-items: center;
                position: relative;
                span {
                    font-size: 16px;
                    color: #999999;
                    padding: 0 12px;
                    line-height: 30px;
                    width: 36px;
                    text-align: center;
                    cursor: pointer;
                }
                span.on {
                    background: #ffffff;
                    border-radius: 15px;
                    color: #333333;
                    font-weight: bold;
                    position: relative;
                    z-index: 1;
                }
                span.new {
                    margin-left: -10px;
                    background-repeat: no-repeat;
                    background-position: 47px center;
                    background-size: 10px 16px;
                    -webkit-filter: grayscale(.95);
                    background-image: url('~@/assets/new/icon-zx.png');
                }
                span.up {
                    -webkit-filter: grayscale(0);
                    background-image: url('~@/assets/new/icon-zx.png');
                }
                span.down {
                    -webkit-filter: grayscale(0);
                    background-image: url('~@/assets/new/icon-dx.png');
                }
            }
        }
        .comment-content-box {
            margin-top: 30px;
            ul.comment-content-list {
                li.comment-item {
                    margin-top: 20px;
                    padding-left: 37px;
                    padding-bottom: 20px;
                    position: relative;
                    border-bottom: 1px solid #e5e5e5;
                    .item-user-portrait {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 30px;
                        height: 30px;
                        overflow: hidden;
                        border-radius: 50%;
                        img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                    .item-user-info {
                        margin-bottom: 8px;
                        height: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        h4 {
                            color: #333333;
                            font-size: 16px;
                            font-weight: 500;
                            display: flex;
                            align-items: center;
                            .me {
                                display: inline-block;
                                vertical-align: middle;
                                margin-top: 2px;
                                border: 1px solid #999999;
                                color: #999999;
                                font-size: 12px;
                                margin-left: 8px;
                                border-radius: 4px;
                                padding: 0 4px;
                                line-height: 16px;
                            }
                        }
                    }
                    .item-test,
                    .items-item-test {
                        font-size: 16px;
                        color: #666666;
                        font-weight: 400;
                        line-height: 30px;
                    }
                    .item-img-list {
                        display: flex;
                        align-items: center;
                        div.item-img-item {
                            flex: 0 0 30%;
                            height: 160px;
                            margin-right: 20px;
                            img {
                                display: block;
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                    }

                    .item-comment-box {
                        margin-top: 15px;
                        // display: flex;
                        // justify-content: space-around;
                        // align-items: flex-end;
                        .item-comment-input {
                            display: inline-block;
                            vertical-align: top;
                            width: 83.4%;
                            textarea {
                                border-radius: 10px;
                                border: 1px solid #E0E0E0;
                            }
                        }
                        .item-comment-btn {
                            display: inline-block;
                            vertical-align: bottom;
                            width: 74px;
                            height: 33px;
                            color: #ffffff;
                            border-radius: 10px;
                            font-size: 18px;
                            border: none;
                            background: #f75959;
                            margin-left: 34px;
                        }
                    }
                    .items-comment-content-box {
                        margin-top: 15px;
                        ul.items-comment-content-list {
                            background: #f9f9f9;
                            border-radius: 10px;
                            padding: 0 20px 20px;
                            li.items-comment-item {
                                border-bottom: 1px solid #e5e5e5;
                                padding-bottom: 16px;
                                .item-user-info {
                                    height: 50px;
                                    margin-bottom: 0;
                                    .items-hf {
                                        color: #333333;
                                        font-size: 16px;
                                        i {
                                            color: #999999;
                                            padding: 0 6px;
                                        }
                                    }
                                }
                            }
                            li.items-comment-item:last-child {
                                border-bottom: none;
                            }
                        }
                    }
                    .look-more {
                        display: flex;
                        align-items: center;
                        height: 16px;
                        margin-top: 20px;
                        span {
                            color: #f75959;
                            font-size: 16px;
                            cursor: pointer;
                        }
                    }
                }
                li.comment-item:last-child {
                    border-bottom: none;
                }
            }
        }
    }
    .report-dialog {
        .el-dialog__body {
            padding-top: 0;
        }
    }
    .report-box {
        .issue-label {
            color: #333333;
            font-size: 16px;
            font-weight: 600;
            line-height: 48px;
        }
        .option-report-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            li {
                margin-right: 12px;
                min-width: 120px;
                text-align: center;
                margin-bottom: 20px;
                padding: 6px;
                border: 1px solid #f9f9f9;
                background: #f9f9f9;
                color: #333333;
                font-size: 14px;
                font-weight: 400;
                cursor: pointer;
            }
            li.on {
                border: 1px solid #f75959;
                color: #f75959;
            }
        }
        .report-btn {
            display: flex;
            justify-content: center;
            margin-top: 30px;
            button {
                flex: 0 0 100px;
                height: 30px;
                background: #f75959;
                color: #ffffff;
                font-size: 14px;
                font-weight: 400;
                border: 1px solid #f75959;
                line-height: 28px;
            }
        }
    }
    .link-card-box {
        margin: 1em auto;
        width: 390px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 12px;
        max-width: 100%;
        overflow: hidden;
        display: flex;
                align-items: center;
                justify-content: space-between;
                border-radius: inherit;
                background-color: hsla(0,0%,96.5%,.88);
                padding: 12px;
        // a {
            // > span {
            //     display: flex;
            //     align-items: center;
            //     justify-content: space-between;
            //     border-radius: inherit;
            //     background-color: hsla(0,0%,96.5%,.88);
            //     padding: 12px;
            // }
        // }
        .link-card-text {
            flex: 0 0 300px;
            overflow: hidden;
            .link-card-title {
                display: block;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                max-height: 40px;
                font-size: 16px;
                font-weight: 500;
                line-height: 1.25;
                word-wrap: break-word;
                color: #121212;
            }
            .link-card-meta{
                // display: -webkit-box;
                // display: -ms-flexbox;
                // display: flex;
                display: block;
                margin-top: 4px;
                font-size: 14px;
                line-height: 20px;
                color: #999;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: initial;
                word-wrap: break-word;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
        .link-card-image-cell {
            margin-left: 8px;
            border-radius: 6px;
            min-width: 60px;
            min-height: 60px;
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
.text-center {
    li {
        text-align: center;
    }
}
</style>